import { ReactNode } from 'react';

import { useSelector } from 'react-redux';

import { ICmsEntry } from '@@/auto/interfaces';
import { parseHTML } from '@@/auto/services/transformCmsData';
import { getCmsEntry } from '@@/auto/store/selectors';

export type TRenderCmsContent = (content: {
  cmsContent: ICmsEntry;
  parseHTML: typeof parseHTML;
}) => ReactNode;

export type TCmsContent = {
  'data-testid': string;
  entrySlug: string;
  modelSlug: string;
  overrideClasses?: Partial<{ root: string }>;
  renderContent: TRenderCmsContent;
};

export default function CmsContent({
  'data-testid': dataTestId,
  entrySlug,
  modelSlug,
  overrideClasses = {},
  renderContent,
}: TCmsContent) {
  const cmsContent = useSelector(getCmsEntry(modelSlug, entrySlug));

  if (!cmsContent) {
    return (
      <section data-testid={`${dataTestId}-error`}>
        <p>Content Unavailable</p>
        <p>Please try refreshing the page.</p>
      </section>
    );
  }

  return (
    <section className={overrideClasses.root} data-testid={dataTestId}>
      {renderContent({ cmsContent, parseHTML })}
    </section>
  );
}
